import {useContext, useEffect, useState} from 'react';
import {DIRECTORY_TYPE} from 'constants/directory-type';
import {useDispatch, useSelector} from 'react-redux';
import {useParams} from 'react-router';
import {parseValidationErrors} from 'services/api/utils/parse-error';
import {selectDirectory} from 'store/directory/endpoints/show-directory';
import {
  UpdateDirectoryRequest,
  useUpdateDirectoryMutation,
} from 'store/directory/endpoints/update-directory';
import {useSeeder} from 'utils/use-seeder';
import {useTranslation} from 'react-i18next';
import toast from 'store/ui/actions/toast';
import {AbilityContext} from 'features/hylian-shield';
import {AbilityContextType} from 'features/hylian-shield/types';

const __DEV__ = process.env.NODE_ENV === 'development';

export default () => {
  const [send, {isLoading, error, isSuccess}] = useUpdateDirectoryMutation();

  const serverError = parseValidationErrors(error);

  const fake = useSeeder();
  const {id} = useParams();

  const {checkAbility} = useContext(AbilityContext) as AbilityContextType;

  const canEdit = checkAbility('edit', 'directory');

  const [params, setParams] = useState<Params>({
    company_name: '',
    directory_categories: [],
    families: [],
    comment: '',
    email: '',
    color_code: '',
    job: '',
    reference_contact: undefined,
    requirement_rate: undefined,
    newsletters: undefined,
    website: '',
    directory_type: DIRECTORY_TYPE.COMPANY, //important to hardcode here to not create two files that do the same
  });
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const handleSubmit = async () => {
    const result = await send(params);
    if ('data' in result) {
      dispatch(toast('success', t('common.changesCommited')));
    } else {
      const {message} = parseValidationErrors(result.error);
      dispatch(toast('error', message));
    }
  };
  const {data} = useSelector(selectDirectory({id}));
  const directory = data?.data;
  useEffect(() => {
    if (params.directory_categories.length === 0) {
      setParams({
        ...params,
        families: [],
      });
    }
  }, [params.directory_categories]);
  useEffect(() => {
    if (directory) {
      setParams({
        ...params,
        id: directory.id,
        color_code: directory.color_code,
        company_name: directory.company_name,
        directory_categories: directory.directory_categories,
        families: directory.directory_families,
        comment: directory.comment,
        newsletters: directory.newsletters,
        website: directory.website,
        job: directory.job,
        reference_contact: directory.reference_contact,
        residency_country: directory.residency_country,
        requirement_rate: directory.requirement_rate,
        is_official_suppliers_small_items:
          directory.is_official_suppliers_small_items,
        is_official_furniture_supplier:
          directory.is_official_furniture_supplier,
        is_official_studio_supplier: directory.is_official_studio_supplier,
      });
    }
  }, [directory]);

  return {
    setParams,
    params,
    directory,
    isLoading,
    validationErrors: serverError.errors,
    errorMessage: serverError.message,
    submit: handleSubmit,
    isSuccess,
    canEdit,
  };
};

type Params = UpdateDirectoryRequest;
